import { CommonStatusTag } from 'components/CommonStatusTag';

import { colors } from 'constants/colors';

import { SiteDeliveryType } from 'data/__generated__';
import { SITE_DELIVERY_TYPES_LABELS } from 'pages/Sites/constants/types';

const getColorsFromDeliveryType = (deliveryType: SiteDeliveryType) => {
    const { pureWhite, emeraldBlue, blandBlue, orange } = colors;

    switch (deliveryType) {
        case SiteDeliveryType.MicrostoreDelivery:
            return { backgroundColor: emeraldBlue, labelColor: pureWhite };
        case SiteDeliveryType.WarehouseDelivery:
            return { backgroundColor: blandBlue, labelColor: pureWhite };
        case SiteDeliveryType.PackageDelivery:
            return { backgroundColor: orange, labelColor: pureWhite };
        case SiteDeliveryType.RefrigeratedTruckDelivery:
            return { backgroundColor: emeraldBlue, labelColor: pureWhite };
    }
};

export const DeliveryTypeTag = ({ deliveryType }: { deliveryType: SiteDeliveryType }) => {
    const { backgroundColor, labelColor } = getColorsFromDeliveryType(deliveryType);
    return (
        <CommonStatusTag
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            label={SITE_DELIVERY_TYPES_LABELS[deliveryType]}
        />
    );
};
